import React from 'react'
import PropTypes from 'prop-types'
import Link, { LINK_SIZES } from 'components/Link'
import './RichTextLinksBlock.scss'

const RichTextLinksBlock = ({ links }) => {
    return links ? (
        <ul className="rich-text-links-block">
            {links.map((link, index) => (
                <li key={index} className="rich-text-links-block__item">
                    <Link {...link} size={LINK_SIZES.large} />
                </li>
            ))}
        </ul>    
    ) : null
}

RichTextLinksBlock.propTypes = {
    links: PropTypes.arrayOf(Link.propTypes),
}

export default RichTextLinksBlock
